import React, { useState, useEffect, useCallback, Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MapboxGl from "mapbox-gl";
import { useParams, useLocation } from "react-router-dom";
import Logo from "../images/LOGO/logo4.png";
import "mapbox-gl/dist/mapbox-gl.css";
import {
  TextField,
  Backdrop,
  CircularProgress,
  Fab,
  Button,
  ButtonGroup,
  Popper,
  Paper,
  Typography,
  MenuList,
  MenuItem,
  Popover,
  FormControl,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import { MdLocationOn } from "react-icons/md";
import { FaPlus, FaMinus } from "react-icons/fa";
import { BiCurrentLocation } from "react-icons/bi";
import { getMapserviceStyles } from "../API/mapservice";
import {
  Scsprivate,
  Scspublic,
  ScsprivateDetail,
  ScspublicDetail,
} from "../API/scs";
import Marker from "../images/custom_marker.png";
import { GrResources } from "react-icons/gr";
import _ from "lodash";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
  panel: {
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      zIndex: 10,
      right: "1rem",
      bottom: "3rem",
      display: "flex",
      flexDirection: "column",
    },

    [theme.breakpoints.up("md")]: {
      position: "absolute",
      zIndex: 10,
      right: "2rem",
      bottom: "5rem",
      display: "flex",
      flexDirection: "column",
    },
  },
  multilineColor: {
    color: "black",
    backgroundColor: "white",
    borderRadius: "0.5rem",
    //fontWeight: 600,
  },
  btn: {
    marginTop: "1rem",
    backgroundColor: "white",
    borderRadius: "6px",
    boxShadow:
      "0px 3px 5px -1px rgb(0 0 0 / 5%), 0px 6px 10px 0px rgb(0 0 0 / 5%), 0px 1px 18px 0px rgb(0 0 0 / 5%)",
    height: "44px",
    width: "40px",
  },
  root: {
    height: "100vh",
    width: "100vw",
    "& .mapboxgl-control-container": {
      "& .mapboxgl-ctrl-top-right": {
        display: "none",
      },
      "& .mapboxgl-ctrl-bottom-right": {
        display: "none",
      },
    },
  },
  autocomplete: {
    backgroundColor: "#fff",

    "& .MuiOutlinedInput-input": {
      fontWeight: 200,
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 1.6,
    },
    "& .MuiOutlinedInput-notchedOutline": {},
    "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*=MuiOutlinedInput-root]":
      {
        paddingRight: "unset",
      },
    "& div.MuiChip-root.MuiAutocomplete-tag.MuiChip-deletable": {
      fontWeight: 400,
    },
    "& span.MuiAutocomplete-tag": {
      fontWeight: 400,
    },
    "& .MuiAutocomplete-option[data-selected=true]": {
      fontWeight: 200,
    },
  },
  atc: {
    fontWeight: 200,
  },
  autopopup: {
    "& .MuiAutocomplete-popupIndicatorOpen": {
      transform: "rotate(0deg)",
    },
  },
  buttonfilter: {
    whiteSpace: "nowrap",

    backgroundColor: "#E16733",
    color: "#ffffff",
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    "&:hover": {
      backgroundColor: "#E16733",
      color: "#ffffff",
      // boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  cardStyle: {
    boxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    borderRadius: 8,
  },
  listtext: {
    fontWeight: 200,
    "&:hover": {
      color: "#E16733",
    },
    cursor: "pointer",
  },
  currenttext: {
    fontWeight: 200,
    color: "#E16733",
    cursor: "pointer",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  searchComp: {
    [theme.breakpoints.down("sm")]: {
      zIndex: 10,
      position: "fixed",
      margin: "2rem 1rem",
      width: "-webkit-fill-available",
    },

    [theme.breakpoints.up("md")]: {
      zIndex: 10,
      position: "fixed",
      left: "2rem",
      top: "2rem",
      width: "36rem",
    },
  },

  loadingpaper: {
    [theme.breakpoints.down("sm")]: {
      // zIndex: 10,
      // position: "fixed",
      overflow: "auto",
      maxHeight: "20rem",
      margin: "unset",
      width: "29.2rem",
    },

    [theme.breakpoints.up("md")]: {
      // zIndex: 10,
      // position: "fixed",
      // left: "2rem",
      // top: "2rem",
      overflow: "auto",
      maxHeight: "20rem",
      width: "36rem",
    },
  },
  textWidth: {
    [theme.breakpoints.down("sm")]: {
      maxWidth: "24rem",
    },

    [theme.breakpoints.up("md")]: {
      maxWidth: "31rem",
    },
  },

  logo: {
    [theme.breakpoints.down("sm")]: {
      height: "30px",
      position: "absolute",
      right: 10,
      bottom: 0,
      zIndex: 10,
    },

    [theme.breakpoints.up("md")]: {
      height: "70px",
      position: "absolute",
      right: 10,
      bottom: 0,
      zIndex: 10,
    },
  },
  toggle: {
    "& .MuiPopover-paper": {
      boxShadow:
        "0px 3px 5px -1px rgb(0 0 0 / 5%), 0px 6px 10px 0px rgb(0 0 0 / 5%), 0px 1px 18px 0px rgb(0 0 0 / 5%)",
      padding: 16,
    },
  },
}));

const Embed = () => {
  const classes = useStyles();
  const { apikey } = useParams();
  const { search } = useLocation();
  const searchParam = new URLSearchParams(search);
  const [map, setmap] = useState(undefined);
  const [searchText, setsearchText] = useState("");
  const [options, setoptions] = useState([]);
  const [loading, setloading] = useState(false);
  const [disabled, setdisabled] = useState(true);
  const [opensearch, setopensearch] = useState(undefined);
  const [Load, setLoad] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isSCS, setSCS] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [toggleList, setToggleList] = useState([
    {
      label: `ระบบไฟฟ้าบนดิน`,
      urlService: ``,
      layerId: `electrical-system-ongrounds`,
      open: true,
    },
    {
      label: `ระบบไฟฟ้าสาธารณะ`,
      urlService: ``,
      layerId: `electrical-system-publics`,
      open: false,
    },
    {
      label: `ระบบไฟฟ้าใต้ดิน`,
      urlService: ``,
      layerId: `electrical-system-undergrounds`,
      open: false,
    },
    {
      label: `สายสื่อสาร`,
      urlService: ``,
      layerId: `fiber-optic-cables`,
      open: false,
    },
  ]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const onClickMap = async (e) => {
    const abortController = new AbortController();

    if (searchParam.get("type") === "private") {
      const data = await ScsprivateDetail(
        abortController,
        apikey,
        e.lngLat.lat,
        e.lngLat.lng
      );

      if (data) {
        window.parent.postMessage(data, "*");
      } else {
        const dataagian = await ScspublicDetail(
          abortController,
          apikey,
          e.lngLat.lat,
          e.lngLat.lng
        );

        window.parent.postMessage(dataagian, "*");
      }
    } else {
      const data = await ScspublicDetail(
        abortController,
        apikey,
        e.lngLat.lat,
        e.lngLat.lng
      );

      if (data) {
        window.parent.postMessage(data, "*");
      }
    }
  };

  useEffect(() => {
    const onMove = (e) => {
      var coords = e.lngLat;

      let geojson = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            properties: {
              poleid: "pole-one",
              position: 0,
            },
            geometry: {
              type: "Point",
              coordinates: [coords.lng, coords.lat],
            },
          },
        ],
      };

      const checkLayer = map
        .getStyle()
        .layers.filter((rs) => rs.id === "Mark-point");

      if (!checkLayer.length) {
        map.loadImage(Marker, function (error, image) {
          map.addImage("custom-marker", image);

          map.addSource("points-data", {
            type: "geojson",
            data: geojson,
          });
          map.addLayer({
            id: "Mark-point",
            type: "symbol",
            source: "points-data",
            layout: {
              "icon-image": "custom-marker",
            },
          });
        });
      } else {
        map.getSource("points-data").setData(geojson);
        onClickMap(e);
      }

      // map.getSource("points-data").setData(geojson);
      //
    };

    if (map) {
      map.on("click", "Mark-point", function (e) {
        e.preventDefault();
        onClickMap(e);
      });

      map.on("click", function (e) {
        e.preventDefault();

        e.target.on("click", onMove);
      });
    }

    return () => {};
  }, [map]);

  const initMap = useCallback(async () => {
    const center = searchParam.get("q");
    const zoom = searchParam.get("z");
    const basemap = searchParam.get("mt");

    const meaTiles = await fetch(`${process.env.REACT_APP_MEA_TILE}`)
      .then((rs) => rs.json())
      .then((rs) => rs);
    const apiKeyOrtho = await fetch(`${process.env.REACT_APP_MAPSTD}`)
      .then((rs) => rs.text())
      .then((rs) => rs);

    const combindLayers = meaTiles;

    combindLayers.sources = {
      ...combindLayers.sources,
      "mea-ortho": {
        type: "raster",
        tiles: [
          `${process.env.REACT_APP_MEAORTHO}/tile/{z}/{y}/{x}?token=${apiKeyOrtho}&blankTile=false`,
        ],
        tileSize: 256,
      },
    };

    combindLayers.layers = [
      ...combindLayers.layers,
      {
        id: "mea-ortho",
        type: "raster",
        source: "mea-ortho",
        minzoom: 0,
        maxzoom: 22,
        layout: {
          visibility: basemap === "satellite" ? "visible" : "none",
        },
      },
    ];

    let serviceList = [];
    if (searchParam.get("type") === "private") {
      serviceList = [
        "landbases",
        "landmark-points",
        "electrical-system-ongrounds",
      ];
    } else {
      serviceList = ["landbases", "landmark-points"];
    }

    //private function

    const promiseMapservice = await serviceList.map((layerId) =>
      getMapserviceStyles(apikey, layerId)
    );

    const rsMapserviceStyles = await Promise.all(promiseMapservice);

    const MapserviceStylesfilter = rsMapserviceStyles.filter(
      (fl) => !fl.status
    );

    let preStyle = {
      ...combindLayers,
      layers: combindLayers.layers.filter((layer) => layer),
    };

    await MapserviceStylesfilter.map((rs, index) => {
      const mapserviceStyle = rs;

      preStyle.sprite = mapserviceStyle.sprite;
      preStyle.glyphs = mapserviceStyle.glyphs;

      preStyle.sources = {
        ...preStyle.sources,
        ...mapserviceStyle.sources,
      };
      preStyle.layers = [...preStyle.layers, ...mapserviceStyle.layers];
      return null;
    });
    const uniqCustom = _.uniqBy(preStyle.layers, "id");

    const mapRender = new MapboxGl.Map({
      container: "map",
      style: { ...preStyle, layers: uniqCustom },
      center: center
        ? [center.split(",")[0], center.split(",")[1]]
        : [100.554894, 13.721237],
      zoom: zoom ? zoom : 10,
      bounds: [100.315185, 13.478294, 100.94301, 13.974256],
      maxBounds: [97.3, 5.59, 105.660416, 20.503936],
    });

    mapRender.on("load", async (e) => {
      if (!center) {
        navigator.geolocation.getCurrentPosition((position) => {
          const cen = [position.coords.longitude, position.coords.latitude];

          const geojson = {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                properties: {
                  poleid: "pole-one",
                  position: 0,
                },
                geometry: {
                  type: "Point",
                  coordinates: cen,
                },
              },
            ],
          };

          const checkLayer = e.target
            .getStyle()
            .layers.filter((rs) => rs.id === "Mark-point");

          if (!checkLayer.length) {
            e.target.loadImage(Marker, function (error, image) {
              e.target.addImage("custom-marker", image);

              e.target.addSource("points-data", {
                type: "geojson",
                data: geojson,
              });
              e.target.addLayer({
                id: "Mark-point",
                type: "symbol",
                source: "points-data",
                layout: {
                  "icon-image": "custom-marker",
                },
              });
            });
          } else {
            e.target.getSource("points-data").setData(geojson);
          }
          if (zoom) {
            e.target.flyTo({
              zoom: zoom,
              center: cen,
              speed: 2,
              curve: 1,
            });
          }

          const coor = {
            lngLat: { lng: cen[0], lat: cen[1] },
          };

          // init send addEventListener
          if (searchParam.get("init_data") == "true") {
            onClickMap(coor);
          }
        });
      } else {
        const geojson = {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              properties: {
                poleid: "pole-one",
                position: 0,
              },
              geometry: {
                type: "Point",
                coordinates: [center.split(",")[0], center.split(",")[1]],
              },
            },
          ],
        };

        const checkLayer = e.target
          .getStyle()
          .layers.filter((rs) => rs.id === "Mark-point");

        if (!checkLayer.length) {
          e.target.loadImage(Marker, function (error, image) {
            e.target.addImage("custom-marker", image);

            e.target.addSource("points-data", {
              type: "geojson",
              data: geojson,
            });
            e.target.addLayer({
              id: "Mark-point",
              type: "symbol",
              source: "points-data",
              layout: {
                "icon-image": "custom-marker",
              },
            });
          });
        } else {
          e.target.getSource("points-data").setData(geojson);
        }
        if (zoom) {
          e.target.flyTo({
            zoom: zoom,
            center: [center.split(",")[0], center.split(",")[1]],
            speed: 2,
            curve: 1,
          });
        }

        const coor = {
          lngLat: { lng: center.split(",")[0], lat: center.split(",")[1] },
        };

        // init send addEventListener
        if (searchParam.get("init_data") == "true") {
          onClickMap(coor);
        }
      }

      setmap(e.target);
    });

    mapRender.once("idle", async (e) => {
      try {
        const check = await fetch(
          `${process.env.REACT_APP_SERVICE_URL}/v1.0/mapservices/electrical-system-ongrounds/styles?api_key=${apikey}`
        )
          .then((rs) => rs.status)
          .then((rs) => rs);

        if (check === 200) {
          setSCS(true);
          if (searchParam.get("type") === "public") {
          } else {
            const vectorTiles = await fetch(
              `${process.env.REACT_APP_SERVICE_URL}/v1.0/mapservices/electrical-system-ongrounds/styles?api_key=${apikey}`
            )
              .then((rs) => rs.json())
              .then((rs) => rs);

            let oldStyle = e.target.getStyle();
            oldStyle.sources = _.merge(
              vectorTiles?.sources,
              e.target.getStyle()?.sources
            );

            oldStyle.layers = _.unionWith(
              e.target.getStyle()?.layers,
              vectorTiles?.layers,
              _.isEqual
            );

            e.target.setStyle(oldStyle);
          }
        } else {
          setSCS(false);
        }
      } catch (error) {
        setSCS(false);
      }
    });

    mapRender.once("idle", (e) => {
      setdisabled(false);
    });
  }, []);

  useEffect(() => {
    if (!map) {
      initMap();
    }
    return () => {
      if (map) {
        map.remove();
        setmap(undefined);
      }
    };
  }, [initMap, map]);

  const elasticSearch = useCallback(
    async (abortController) => {
      if (searchText !== "" && searchText) {
        setloading(true);
        setTimeout(async () => {
          if (searchParam.get("type") === "private") {
            const ListSearch = await Scsprivate(
              abortController,
              apikey,
              searchText
            );

            if (ListSearch.length) {
              setoptions(ListSearch);
              setloading(false);
            } else {
              const ListSearchAgian = await Scspublic(
                abortController,
                apikey,
                searchText
              );

              if (ListSearchAgian.length) {
                setoptions(ListSearchAgian);
                setloading(false);
              } else {
                setloading(false);
              }
            }
          } else {
            const ListSearch = await Scspublic(
              abortController,
              apikey,
              searchText
            );

            if (ListSearch.length) {
              setoptions(ListSearch);
              setloading(false);
            } else {
              setloading(false);
            }
          }
        }, 10);
      } else {
        setloading(false);
        setsearchText("");
        setoptions([]);
      }
    },
    [searchText, apikey, searchParam]
  );
  useEffect(() => {
    const abortController = new AbortController();
    elasticSearch(abortController);

    return () => {
      abortController.abort();
    };
  }, [searchText]);

  const moveToselectobject = async (obj) => {
    if (obj) {
      setLoad(false);
    }

    map.flyTo({
      center: [obj.lon, obj.lat],
      zoom: 17,
      speed: 2,
      curve: 1,
    });

    const coor = {
      lngLat: { lng: obj.lon, lat: obj.lat },
    };

    onClickMap(coor);

    const geojson = {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          properties: {
            poleid: "pole-one",
            position: 0,
          },
          geometry: {
            type: "Point",
            coordinates: [obj.lon, obj.lat],
          },
        },
      ],
    };

    const checkLayer = map
      .getStyle()
      .layers.filter((rs) => rs.id === "Mark-point");

    if (!checkLayer.length) {
      map.loadImage(Marker, function (error, image) {
        map.addImage("custom-marker", image);

        map.addSource("points-data", {
          type: "geojson",
          data: geojson,
        });
        map.addLayer({
          id: "Mark-point",
          type: "symbol",
          source: "points-data",
          layout: {
            "icon-image": "custom-marker",
          },
        });
      });
    } else {
      map.getSource("points-data").setData(geojson);
    }
  };

  const searchComponent = (
    <div className={classes.searchComp}>
      <TextField
        aria-describedby={"popperMenu"}
        onFocus={(e) => {
          setopensearch(e.currentTarget);
        }}
        onBlur={() => {
          // blur();
        }}
        inputProps={{
          className: classes.multilineColor,
        }}
        value={searchText}
        onChange={(e) => {
          setsearchText(e.target.value);
        }}
        variant="outlined"
        style={{ width: "100%" }}
        size="small"
        placeholder="ค้นหา สถานที่สำคัญ / Lat, Lon / ซอย / ถนน"
      />
      <Popper
        id={"popperMenu"}
        open={opensearch ? true : false}
        anchorEl={opensearch}
        style={{ zIndex: 1000 }}
        placement="bottom-start"
      >
        {searchText && (
          <Paper elevation={3} className={classes.loadingpaper}>
            {options.length === 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "1rem",
                }}
              >
                <Typography variant="body1" component="p" color="primary">
                  {loading ? "กำลังโหลดข้อมูล" : "ไม่พบสถานที่"}
                </Typography>
                {loading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: "1rem" }}
                    disableShrink
                  />
                )}
              </div>
            )}

            {options.length ? (
              <MenuList>
                {options.map((rs, index) => {
                  return (
                    <MenuItem
                      key={rs._id}
                      onClick={() => {
                        if (rs) {
                          setLoad(true);
                          moveToselectobject(rs);
                        } else {
                          setsearchText("");
                          setoptions([]);
                        }
                        setopensearch(undefined);
                      }}
                    >
                      <div style={{ marginRight: "1rem" }}>
                        <Fab style={{ height: 30, width: 35 }} color="primary">
                          <MdLocationOn size={25} />
                        </Fab>
                      </div>
                      <div className={classes.textWidth}>
                        <Typography
                          style={{ whiteSpace: "break-spaces" }}
                          color="primary"
                          variant="body1"
                          component="a"
                        >
                          {rs.keyword}
                        </Typography>
                      </div>
                    </MenuItem>
                  );
                })}
              </MenuList>
            ) : null}
          </Paper>
        )}
      </Popper>

      {/* <Autocomplete
        id="multiple-user-list"
        debug
        loading={loading}
        options={options}
        disabled={disabled}
        onInputChange={(e, v) => {
       
          setsearchText(v);
        }}
        getOptionLabel={(option) => option.keyword}
        style={{ width: "100%" }}
        onChange={(e, v) => {
          if (v) {
         
            setLoad(true);
            moveToselectobject(v);
          } else {
            setsearchText("");
            setoptions([]);
          }
        }}
        className={classes.autopopup}
        classes={{ paper: classes.atc }}
        popupIcon={<FiSearch />}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            fullWidth
            required
            className={classes.autocomplete}
          />
        )}
        renderOption={(option, { inputValue }) => {
          const matches = match(option.keyword, inputValue);

          const parts = parse(option.keyword, matches);

          return (
            <div>
              {parts.map((part, index) => {
                return (
                  <span
                    key={index}
                    style={{
                      fontWeight: part.highlight ? 700 : 400,
                      color: part.highlight ? "#e16733" : "black",
                    }}
                  >
                    {part.text}
                  </span>
                );
              })}
            </div>
          );
        }}
      /> */}
    </div>
  );

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeToggle = async (index, e) => {
    let oldToggle = [...toggleList];
    oldToggle[index].open = e.target.checked;
    let vectorTiles;
    try {
      const check = await fetch(
        `${process.env.REACT_APP_SERVICE_URL}/v1.0/mapservices/${oldToggle[index].layerId}/styles?api_key=${apikey}`
      )
        .then((rs) => rs.json())
        .then((rs) => rs);
      if (check) {
        vectorTiles = check;
      }
    } catch (error) {
      enqueueSnackbar("Map services not support now.", {
        variant: "warning",
        autoHideDuration: 2000,
      });
    }

    if (oldToggle[index].open) {
      if (vectorTiles) {
        let oldStyle = map.getStyle();
        oldStyle.sources = _.merge(
          vectorTiles?.sources,
          map.getStyle()?.sources
        );

        oldStyle.layers = _.unionWith(
          map.getStyle()?.layers,
          vectorTiles?.layers,
          _.isEqual
        );

        map.setStyle(oldStyle);
      }
    } else {
      if (vectorTiles) {
        const keys = Object.keys(vectorTiles?.sources);
        let oldStyle = map.getStyle();
        if (keys) {
          oldStyle.sources = _.omit(map.getStyle()?.sources, keys);

          let layers = map.getStyle().layers;
          keys.map((rs) => {
            layers = layers.filter((ly) => ly.source !== rs);
          });
          oldStyle.layers = layers;
          map.setStyle(oldStyle);
        }
      }
    }
    setToggleList(oldToggle);
  };

  return (
    <Fragment>
      <Backdrop className={classes.backdrop} open={Load}>
        <CircularProgress color="primary" />
      </Backdrop>
      <div id="map" className={classes.root}>
        {searchComponent}
        <img src={Logo} className={classes.logo} alt=""></img>
        <div className={classes.panel}>
          {searchParam.get("type") === "public" ? null : isSCS ? (
            <Fragment>
              <Fab
                className={classes.btn}
                aria-describedby={id}
                onClick={handleClick}
              >
                <GrResources size={25} fill="#595A5A" />
              </Fab>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                className={classes.toggle}
                elevation={0}
              >
                <Fragment>
                  <FormControl component="fieldset">
                    <FormGroup>
                      {toggleList.map((tl, index) => {
                        return (
                          <FormControlLabel
                            key={tl.layerId}
                            control={
                              <Switch
                                checked={tl.open}
                                onChange={(e) => {
                                  changeToggle(index, e);
                                }}
                                name={tl.layerId}
                                color="primary"
                              />
                            }
                            label={tl.label}
                          />
                        );
                      })}
                    </FormGroup>
                  </FormControl>
                </Fragment>
              </Popover>
            </Fragment>
          ) : null}

          <Fab
            className={classes.btn}
            onClick={() => {
              navigator.geolocation.getCurrentPosition((position) => {
                const cen = [
                  position.coords.longitude,
                  position.coords.latitude,
                ];

                const geojson = {
                  type: "FeatureCollection",
                  features: [
                    {
                      type: "Feature",
                      properties: {
                        poleid: "pole-one",
                        position: 0,
                      },
                      geometry: {
                        type: "Point",
                        coordinates: cen,
                      },
                    },
                  ],
                };
                map.flyTo({
                  center: cen,
                  speed: 2,
                  curve: 1,
                });
                const checkLayer = map
                  .getStyle()
                  .layers.filter((rs) => rs.id === "Mark-point");

                if (!checkLayer.length) {
                  map.loadImage(Marker, function (error, image) {
                    map.addImage("custom-marker", image);

                    map.addSource("points-data", {
                      type: "geojson",
                      data: geojson,
                    });
                    map.addLayer({
                      id: "Mark-point",
                      type: "symbol",
                      source: "points-data",
                      layout: {
                        "icon-image": "custom-marker",
                      },
                    });
                  });
                } else {
                  map.getSource("points-data").setData(geojson);
                }

                const coor = {
                  lngLat: { lng: cen[0], lat: cen[1] },
                };

                onClickMap(coor);
              });
            }}
            disabled={map ? false : true}
          >
            <BiCurrentLocation size={25} fill="#595A5A" />
          </Fab>

          <ButtonGroup
            orientation="vertical"
            color="default"
            variant="contained"
            style={{
              marginTop: "1rem",
              boxShadow:
                "0px 3px 5px -1px rgb(0 0 0 / 5%), 0px 6px 10px 0px rgb(0 0 0 / 5%), 0px 1px 18px 0px rgb(0 0 0 / 5%)",
            }}
            disabled={map ? false : true}
          >
            <Button
              style={{
                backgroundColor: "white",
                height: "44px",
                width: "40px",
                padding: "unset",
              }}
              onClick={() => {
                map.zoomIn();
              }}
            >
              <FaPlus fill="#595A5A" />
            </Button>
            <Button
              style={{
                backgroundColor: "white",
                height: "44px",
                width: "40px",
                padding: "unset",
              }}
              onClick={() => {
                map.zoomOut();
              }}
            >
              <FaMinus fill="#595A5A" />
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Fragment>
  );
};

export default Embed;
